import { ClientService } from "../client-service";
import type { TrackEventEnum, TrackOptions } from "./tracking-types";
import type {
  ChannelMetadata,
  ChannelAndUserInChannelMetadata,
} from "@/models";
import type { UserStoreMeUnwrapped } from "@/stores/user.store";

export abstract class AbstractTrackingService extends ClientService {
  initialized = false;

  public async init(_channelMetadata: ChannelMetadata): Promise<void> {
    if (this.initialized) return this.dispose();
  }

  public abstract identifyChannel(channelMetadata: ChannelMetadata): void;

  public abstract identifyUser(
    user: UserStoreMeUnwrapped,
    channelUserMetadata?: ChannelAndUserInChannelMetadata,
  ): void;

  public abstract resetIdentity(): void;

  public abstract track<T extends TrackEventEnum>(
    options: TrackOptions<T>,
  ): void;

  private dispose() {
    // If the tracking service was already initialized, reload the page
    // to apply the user's preferences, since some of the SDKs require a
    // page reload to correctly clean up.

    console.log(
      "[TrackingStore] Tracking services were already initialized, reloading page to apply user preferences",
    );
    window.location.reload();
  }
}
